import { Flex, Form, notification } from "antd";
import { useEffect } from "react";

import "./SalesTargets.scss";
import { useBoundStore } from "store";
import { CaretDownFilled } from "@ant-design/icons";
import variables from "../../../_variables.scss";
import { UserRoles } from "admin/constants";
import { useUpdateOrganization } from "organizations/queries";
import { MoneyInput } from "shared/components";

type Props = {
  name: string;
};

export const SalesTargets = ({ name }: Props) => {
  const [form] = Form.useForm();
  const { mutate: saveMetadata, error } = useUpdateOrganization();
  const [api, notificationContextHolder] = notification.useNotification();
  const { user, currentOrganization } = useBoundStore();
  const isOwner = user?.role === UserRoles.Owner;

  useEffect(() => {
    form.setFieldsValue({
      salesTargetAmount: currentOrganization?.metadata?.salesTargetAmount ?? 0,
      billedProjectsTargetAmount:
        currentOrganization?.metadata?.billedProjectsTargetAmount ?? 0,
      completedProjectsTargetAmount:
        currentOrganization?.metadata?.completedProjectsTargetAmount ?? 0,
    });
  }, [currentOrganization, form]);

  const onBlurHandler = () => {
    if (!isOwner || !currentOrganization) return;

    const salesTargetAmount = form.getFieldValue("salesTargetAmount");
    const billedProjectsTargetAmount = form.getFieldValue(
      "billedProjectsTargetAmount"
    );
    const completedProjectsTargetAmount = form.getFieldValue(
      "completedProjectsTargetAmount"
    );

    const existingMetadata = currentOrganization?.metadata ?? {};

    saveMetadata({
      ...existingMetadata,
      salesTargetAmount,
      billedProjectsTargetAmount,
      completedProjectsTargetAmount,
    });
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Update sales target error",
        description: error?.message,
      });
    }
  }, [error, api]);

  return (
    <div className='sales-targets-container' data-testid='salesTargets'>
      {notificationContextHolder}
      <Form
        form={form}
        name={`${name}_form`}
        data-testid={`${name}_testid`}
        requiredMark={false}
        layout='vertical'
        initialValues={{
          salesTargetAmount: currentOrganization?.metadata?.salesTargetAmount ?? 0,
          billedProjectsTargetAmount:
            currentOrganization?.metadata?.billedProjectsTargetAmount ?? 0,
          completedProjectsTargetAmount:
            currentOrganization?.metadata?.completedProjectsTargetAmount ?? 0,
        }}
        onBlur={onBlurHandler}
      >
        <Flex vertical gap={variables.smallGap}>
          <Flex gap={variables.gap} align='center'>
            <h2>Enter Targets</h2>
            <CaretDownFilled className='sales-targets-icon' />
          </Flex>
          <Flex gap={variables.gap}>
            <Form.Item
              className='form-item-borderless'
              name='salesTargetAmount'
              label='Sales'
              data-testid={`${name}_salesTargetAmount_testid`}
            >
              <MoneyInput
                size='middle'
                variant='outlined'
                disabled={!isOwner}
              />
            </Form.Item>
            <Form.Item
              className='form-item-borderless'
              name='billedProjectsTargetAmount'
              label='Billed Projects'
              data-testid={`${name}_billedProjectsTargetAmount_testid`}
            >
              <MoneyInput
                size='middle'
                variant='outlined'
                disabled={!isOwner}
              />
            </Form.Item>
            <Form.Item
              name='completedProjectsTargetAmount'
              label='Completed Projects'
              data-testid={`${name}_completedProjectsTargetAmount_testid`}
            >
              <MoneyInput
                size='middle'
                variant='outlined'
                disabled={!isOwner}
              />
            </Form.Item>
          </Flex>
        </Flex>
      </Form>
    </div>
  );
};
